"use client"

import { useMutation } from "@tanstack/react-query"
import { startTiktokAuthAction, type TiktokAuthStart } from "@/server-actions/tiktok-connect"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


/**
 * Stores the CSRF nonce and returns the URL to open in the OAuth popup. The
 * channel row is created/updated by the callback route, so there is nothing to
 * invalidate here — the caller refreshes its channel list once the popup
 * reports back.
 */
export function useStartTiktokAuthMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsTiktokConnect")

  return useMutation({
    mutationFn: async (input: { agentId: string }): Promise<TiktokAuthStart> => {
      const result = await withQueryHandling(startTiktokAuthAction(input), {
        loading: tUi("preparingTikTokAuthorization"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
